import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface Props {
  roles: Array<"admin" | "coach" | "agent" | "vendor" | "casting_professional" | "studio" | "producer">;
  children: ReactNode;
  fallback?: string;
}

export default function RequireRole({ roles, children, fallback = "/auth" }: Props) {
  const { user, hasRole, isLoading } = useAuth();
  if (isLoading) {
    return <div className="container py-12"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  }
  if (!user) return <Navigate to={fallback} replace />;
  // CEO/super_admin bypass: admin role covers it
  if (!roles.some((r) => hasRole(r as any))) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}